import { render, staticRenderFns } from "./AboutTBS.vue?vue&type=template&id=4a491e82&"
import script from "./AboutTBS.vue?vue&type=script&lang=js&"
export * from "./AboutTBS.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports